function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'react-dates/initialize';
import React, { Component } from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import SingleDatePicker from 'react-dates/lib/components/SingleDatePicker';
import { SingleDatePickerPhrases } from 'react-dates/lib/defaultPhrases';
import Icon from '../Icon';
import Input from '../Input';
import Button from '../Button';
import MobileFilter from './MobileFilter';
import { compareMoment, getInputValue, TouchListeners, getInitialSelectedFilter } from './utils';

var SingleDatePickerMobile = /*#__PURE__*/function (_Component) {
  _inherits(SingleDatePickerMobile, _Component);

  var _super = _createSuper(SingleDatePickerMobile);

  function SingleDatePickerMobile(props) {
    var _this;

    _classCallCheck(this, SingleDatePickerMobile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      var selectByTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var onDateChange = _this.props.onDateChange;

      if (Moment(date).isValid()) {
        _this.setState({
          date: date
        }, function () {
          if (selectByTouch) {
            _this.setState({
              selectedFilterIdx: -1
            });
          } // adding set timeout to focus correctly since internal react-dates method update focus to <body>


          setTimeout(function () {
            _this.setCalendarFocus();
          }, 10);
        });
      }

      onDateChange(date);
    });

    _defineProperty(_assertThisInitialized(_this), "clearDateState", function () {
      _this.setState({
        date: null,
        selectedFilterIdx: -1
      });

      _this.onDateChange(null);
    });

    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
      var _this$props = _this.props,
          onFocusChange = _this$props.onFocusChange,
          onAccept = _this$props.onAccept;
      var _this$state = _this.state,
          date = _this$state.date,
          selectedFilterIdx = _this$state.selectedFilterIdx;

      _this.setOrRemoveTouchListeners(false);

      _this.setState({
        focused: null,
        prevDate: date,
        prevSelectedFilterIdx: selectedFilterIdx
      });

      onFocusChange(null);
      onAccept();
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var onCancel = _this.props.onCancel;
      var _this$state2 = _this.state,
          prevDate = _this$state2.prevDate,
          prevSelectedFilterIdx = _this$state2.prevSelectedFilterIdx;

      _this.setState({
        date: prevDate,
        focused: null,
        selectedFilterIdx: prevSelectedFilterIdx
      });

      _this.setOrRemoveTouchListeners(false);

      onCancel();
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocusChange", function (_ref) {
      var focused = _ref.focused;
      var onFocusChange = _this.props.onFocusChange;

      _this.setState({
        focused: focused
      }, function () {
        setTimeout(function () {
          _this.setOrRemoveTouchListeners(focused);
        }, 100);
      });

      onFocusChange(focused);
    });

    _defineProperty(_assertThisInitialized(_this), "setOrRemoveTouchListeners", function () {
      var set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (set) {
        _this.TouchListeners.setTouchListeners();

        _this.setCalendarFocus();
      } else {
        _this.TouchListeners.removeTouchListeners();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setCalendarFocus", function () {
      var date = _this.state.date;
      var calendarDayToday = document.querySelector('.CalendarDay__today');
      var calendarDaySelected = document.querySelector('.CalendarDay__selected');

      if (date === null) {
        calendarDayToday.focus();
      }

      if (calendarDaySelected) {
        calendarDaySelected.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkWithFilter", function () {
      var filters = _this.props.filters;

      if (filters.length > 0) {
        document.querySelector('div.SingleDatePicker_picker').classList.add('datepicker__mobile--withFilter');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterChange", function (ownProps) {
      var _this$props2 = _this.props,
          filters = _this$props2.filters,
          onFilter = _this$props2.onFilter;
      var date = filters[ownProps.index].date;

      _this.onDateChange(date, false);

      onFilter && onFilter({
        date: date,
        selectedFilterButtonName: "filterBtn-".concat(ownProps.index + 1)
      });

      _this.setState({
        selectedFilterIdx: ownProps.index,
        elKey: date
      });

      _this.setCalendarFocus();
    });

    _defineProperty(_assertThisInitialized(_this), "renderCalendarInfoFunc", function () {
      var _this$state3 = _this.state,
          date = _this$state3.date,
          selectedFilterIdx = _this$state3.selectedFilterIdx;
      var _this$props3 = _this.props,
          placeholder = _this$props3.placeholder,
          displayFormat = _this$props3.displayFormat,
          filters = _this$props3.filters,
          presetDatesLabel = _this$props3.presetDatesLabel;
      return /*#__PURE__*/React.createElement("div", {
        className: "position-absolute top-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "position-fixed bottom-0 height-auto padding-lg width-100p bgcolor-white border-top bordercolor-grey"
      }, /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        kind: "primary",
        onClick: _this.closeCalendar,
        className: "width-100p",
        disabled: !date
      }, "Apply")), /*#__PURE__*/React.createElement("div", {
        className: "position-fixed height-auto width-100p bgcolor-white zindex-2"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "position-absolute right-0 top-sm",
        kind: "borderless",
        size: "medium",
        onClick: _this.clearDateState,
        disabled: !date
      }, "Clear"), /*#__PURE__*/React.createElement("div", {
        className: "padding-lg margintop-xxl"
      }, /*#__PURE__*/React.createElement(Input, {
        id: "date",
        placeholder: placeholder,
        value: getInputValue(date, displayFormat),
        readOnly: true,
        size: "medium"
      }), filters.length > 0 ? /*#__PURE__*/React.createElement(MobileFilter, {
        selectedIdx: selectedFilterIdx,
        filters: filters,
        onChange: _this.onFilterChange,
        label: presetDatesLabel
      }) : null)));
    });

    var _this$props4 = _this.props,
        _filters = _this$props4.filters,
        _this$props4$state = _this$props4.state,
        _date = _this$props4$state.date,
        _focused = _this$props4$state.focused;
    var preselected = getInitialSelectedFilter(_filters);
    _this.state = {
      date: preselected ? preselected.date : _date,
      focused: _focused,
      prevdate: preselected ? preselected.date : _date,
      selectedFilterIdx: preselected ? preselected.idx : -1,
      prevSelectedFilterIdx: preselected ? preselected.idx : -1,
      elKey: preselected ? preselected.date : _date
    };
    _this.TouchListeners = new TouchListeners();
    return _this;
  }

  _createClass(SingleDatePickerMobile, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var state = this.props.state;
      var diffs = compareMoment(prevProps.state, state);

      if (diffs) {
        /* eslint-disable react/no-did-update-set-state */
        this.setState(diffs);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          date = _this$state4.date,
          focused = _this$state4.focused;
      var _this$props5 = this.props,
          customProps = _this$props5.customProps,
          daySize = _this$props5.daySize,
          phrases = _this$props5.phrases;
      return /*#__PURE__*/React.createElement(SingleDatePicker, _extends({}, customProps, {
        daySize: daySize,
        customInputIcon: /*#__PURE__*/React.createElement(Icon, {
          name: "event",
          ariaHidden: false,
          ariaLabel: "Open calendar"
        }),
        navPrev: /*#__PURE__*/React.createElement(Icon, {
          name: "arrow_left"
        }),
        navNext: /*#__PURE__*/React.createElement(Icon, {
          name: "arrow_right"
        }),
        readOnly: true,
        hideKeyboardShortcutsPanel: true,
        keepOpenOnDateSelect: true,
        renderCalendarInfo: this.renderCalendarInfoFunc,
        withFullScreenPortal: true,
        date: date,
        onDateChange: this.onDateChange,
        phrases: _objectSpread(_objectSpread({}, SingleDatePickerPhrases), phrases),
        focused: focused,
        onFocusChange: this.handleFocusChange,
        disableScroll: true,
        orientation: "vertical",
        numberOfMonths: 2,
        onClose: this.onCancel
      }));
    }
  }]);

  return SingleDatePickerMobile;
}(Component);

_defineProperty(SingleDatePickerMobile, "propTypes", {
  customProps: PropTypes.object,
  daySize: PropTypes.number,
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.object
  })),
  onCancel: PropTypes.func,
  onDateChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  onAccept: PropTypes.func,
  onFilter: PropTypes.func,
  phrases: PropTypes.object,
  placeholder: PropTypes.string,
  state: PropTypes.object,
  displayFormat: PropTypes.string,

  /** Label for preset dates (smart dates) section */
  presetDatesLabel: PropTypes.string
});

_defineProperty(SingleDatePickerMobile, "defaultProps", {
  customProps: {},
  filters: [],
  onDateChange: function onDateChange() {},
  onFocusChange: function onFocusChange() {},
  onCancel: function onCancel() {},
  onAccept: function onAccept() {},
  phrases: {},
  state: {},
  displayFormat: 'MM/DD/YYYY',
  presetDatesLabel: 'Preset Date'
});

SingleDatePickerMobile.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onDateChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }, {
      "name": "selectByTouch",
      "type": null
    }],
    "returns": null
  }, {
    "name": "clearDateState",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeCalendar",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onCancel",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleFocusChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ focused }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "setOrRemoveTouchListeners",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "set",
      "type": null
    }],
    "returns": null
  }, {
    "name": "setCalendarFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "checkWithFilter",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onFilterChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "ownProps",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderCalendarInfoFunc",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "SingleDatePickerMobile",
  "props": {
    "customProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "filters": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "date": {
              "name": "object",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "onDateChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocusChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onCancel": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onAccept": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "phrases": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "displayFormat": {
      "defaultValue": {
        "value": "'MM/DD/YYYY'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "presetDatesLabel": {
      "defaultValue": {
        "value": "'Preset Date'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for preset dates (smart dates) section"
    },
    "daySize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onFilter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default SingleDatePickerMobile;